// eslint-disable-next-line no-shadow
enum SessionEventScope {
    SESSION = 'SESSION',
    TASK = 'TASK',
    TASK_STEP = 'TASK_STEP',
}

export default SessionEventScope;
